export default __webpack_public_path__ + "static/media/order_CF.d5a558e1.pdf";